import React from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '../../../styled-base/input/text';

const ColorBox = (props: any) => {
    return (
      <div
        className={`wsBoardThemeTileWrap ${props.isActive ? ' active ' : ''}`}
        style={{cursor: 'pointer'}}
        onClick={e => props.setTheme(e, "themeColor", props.color)}
        >
        <div
            style={{ backgroundColor: props.color }}
            className={`displayCell wsBoardThemeDiv wsBoardThemeTile  `}
        />
      </div>
    )
  }

const ColorBoxes = (props: any) => {
    const { t } = useTranslation();
    const defaultColors = ['#ECEFF1', '#B0BEC5', '#73909C', '#FF9802', '#27B87B',
    '#1BCFB4', '#009588', '#684DB5', '#2E79BA', '#192D4E'];
    const {themeColor, themeName} = props.theme;
    const [color, setColor] = React.useState<string>();
    const setThemeColour = (value: string) => {
        setColor(value);
        props.setTheme(null, 'themeColor', value);
    }
    return (
        <div className="wsBoardTheamWrap">
            <div className="wsBoardTopMenuContent_1">
            <div className="displayTable w100">
                <div className="displayRow">
                <div className="wsBoardBackgroundColor">
                    <div className="wsBoardChooseThemeText">
                    {t('Choose a background color')}
                    </div>
                    {
                        defaultColors.map((color: any, index: number) => 
                        <ColorBox key={`color-${index}`} 
                            color={color} 
                            setTheme={props.setTheme} 
                            isActive={((index == 0 && themeName == 'default') || themeColor == color)}
                        />
                        )
                    }
                </div>
                <div className="wsBoardBackgroundEnter">
                    <div className="displayTable w100">
                    <div className="displayRow">
                        <div className="wsBoardChooseThemeText">
                        {t('Or enter a color')}
                        </div>
                        <div className="enterColor">
                            <TextField
                                inputProps={{
                                    placeholder: t("# hex value"),
                                    onBlur: (e: any) => setThemeColour(e.target.value)
                                }}
                            />
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
                
    )
}

export default ColorBoxes;